import * as fromServiceGroupSubCategories from './service-group-sub-categories.actions';
import {
  initialState,
  serviceGroupSubCategoriesAdapter,
  ServiceGroupSubCategoriesState
} from './service-group-sub-categories.interfaces';

export function reducer(
  state: ServiceGroupSubCategoriesState = initialState,
  action: fromServiceGroupSubCategories.ServiceGroupSubCategoriesAction
): ServiceGroupSubCategoriesState {
  switch (action.type) {
    case fromServiceGroupSubCategories.GET_SERVICE_GROUP_SUB_CATEGORIES_FROM_SERVER_SUCCESS: {
      return {
        ...serviceGroupSubCategoriesAdapter.addMany(action.payload.serviceGroupSubCategories, state)
      };
    }

    default: {
      return state;
    }
  }
}
